export enum CALL_END_BY {
    BY_LOCAL="local",
    BY_REMOTE="remote",
    BY_APP_ERROR="app error"
}